import {Injectable} from '@angular/core'
import {Actions, createEffect, ofType} from '@ngrx/effects'
import {catchError, mergeMap, of} from 'rxjs'

import {show_error_action, show_success_msg_action} from '../action/common/common.action'
import {ExpensePaymentStatusAPIModel} from 'src/models/api.model'
import {PaymentService} from 'src/services/payment/payment.service'
import {
  FETCH_EXPENSE_PAYMENTS_HISTORY,
  FETCH_EXPENSE_PAYMENTS_HISTORY_SUCCESS,
  UPDATE_EXPENSE_PAYMENTS_STATUS, UPDATE_REJECTION_TYPE
} from '../action/payment.action'

@Injectable()
export class PaymentEffects {
  constructor(private actions$: Actions, private paymentService: PaymentService) {}

  update_expense_payments_status$ = createEffect(() =>
    this.actions$.pipe(
      ofType(UPDATE_EXPENSE_PAYMENTS_STATUS),
      mergeMap(action =>
        this.paymentService
          .callUpdateExpensePaymentsStatusApi({ id: action.id, paymentType: action.paymentType, status: action.status, statusUpdateInfo: action.statusUpdateInfo })
          .pipe(
            mergeMap(response => [
              show_success_msg_action({ msg: `Updated Successfully` }),
              action.actionToCallAfterSuccess()
            ]),
            catchError((error: any) => of(show_error_action({ data: null, error: error })))
          )
      )
    )
  )

  fetch_expense_payments_history$ = createEffect(() =>
    this.actions$.pipe(
      ofType(FETCH_EXPENSE_PAYMENTS_HISTORY),
      mergeMap(action =>
        this.paymentService.callFetchExpensePaymentsHistoryApi(action.id, action.paymentType).pipe(
          mergeMap((response: ExpensePaymentStatusAPIModel[]) => [
            FETCH_EXPENSE_PAYMENTS_HISTORY_SUCCESS({ expensePaymentHistory: response })
          ]),
          catchError((error: any) => of(show_error_action({ data: null, error: error })))
        )
      )
    )
  )

  update_rejection_type$ = createEffect(() =>
    this.actions$.pipe(
      ofType(UPDATE_REJECTION_TYPE),
      mergeMap(action =>
        this.paymentService.callUpdateRejectionType(action.id, action.rejectionType)
          .pipe(
            mergeMap(response => [
              show_success_msg_action({ msg: `Updated Successfully` })
            ]),
            catchError((error: any) => of(show_error_action({ data: null, error: error })))
          )
      )
    )
  )
}
